import React, { useEffect, useRef, useContext, useState } from "react";
import SectionTitle from "../../components/section-title";
import Button from "../../components/button";
import ServiceBox from "../../components/service-box";
import ServiceData from "../../data/service.json";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";

const JobDetailsContainer = ({ contRef, classOption = "section-pb", data }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <div
            className={`banner-section service-section position-relative ${classOption}`}
            ref={contRef}
        >
            <div
                className="container p-3"
                style={{
                    borderTop: "solid darkgray",
                    borderBottom: "solid darkgray",
                }}
            >
                <div className="row mb-n7 align-items-center">
                    <div className="col-md-12 col-xl-12 mb-7 text-center">
                        <div className="col-md-12 mt-5">
                            <h3 className="title">
                                <span className="text-primary">
                                    {data["title"]}
                                </span>
                            </h3>
                        </div>
                        {data["department"] ? (
                            <div className="col-md-12 mt-5">
                                Department:{" "}
                                <span className="text-dark">
                                    <b>{data["department"]}</b>
                                </span>
                            </div>
                        ) : (
                            ""
                        )}
                        {data["location"] ? (
                            <div className="col-md-12 mt-3">
                                Location:{" "}
                                <span className="text-dark">
                                    <b>{data["location"]}</b>
                                </span>
                            </div>
                        ) : (
                            ""
                        )}
                        <div className="col-md-12 mt-3">
                            <Button
                                classOption="btn btn-sm btn-primary btn-hover-primary"
                                text="Apply"
                                path={"/job-apply/" + data["path"]}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 col-xl-12 mb-7">
                        {data["details"] &&
                            data["details"].map((main, key) => {
                                return (
                                    <div
                                        className="title-section title-section mb-5"
                                        key={key}
                                    >
                                        <h4
                                            className={`font-weight-bold ${"g-color "}`}
                                        >
                                            <b>{main.name}</b>
                                            {/* <span className="hr"></span> */}
                                        </h4>

                                        {main.note &&
                                            main.note.map(
                                                (detailsData, key) => {
                                                    return (
                                                        <div key={key}>
                                                            <p
                                                                className="b-color mt-5 ms-2"
                                                                key={key}
                                                            >
                                                                <b>
                                                                    {
                                                                        detailsData.title
                                                                    }
                                                                </b>
                                                            </p>
                                                            <ul className="list-items-dot mt-3 ms-3">
                                                                {detailsData.points &&
                                                                    detailsData.points.map(
                                                                        (
                                                                            pointsData,
                                                                            key
                                                                        ) => {
                                                                            return (
                                                                                <li
                                                                                    className=" justify-content-center mt-2"
                                                                                    key={
                                                                                        key
                                                                                    }
                                                                                >
                                                                                    <p
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: pointsData,
                                                                                        }}
                                                                                    ></p>
                                                                                </li>
                                                                            );
                                                                        }
                                                                    )}
                                                            </ul>
                                                        </div>
                                                    );
                                                }
                                            )}
                                    </div>
                                );
                            })}
                    </div>
                    <div className="col-md-12 col-xl-12 mb-7 text-center">
                        <div className="col-md-12">
                            <Button
                                classOption="btn btn-sm btn-primary btn-hover-primary mt-5"
                                text="Apply"
                                path={"/job-apply/" + data["path"]}
                            />
                        </div>
                        <div className="col-md-12">
                            <Button
                                classOption="btn btn-sm btn-primary btn-hover-primary mt-5"
                                text="Other Openings"
                                path="/job-opening"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

JobDetailsContainer.propTypes = {
    classOption: PropTypes.string,
    contRef: PropTypes.string,
    data: PropTypes.any,
};

export default JobDetailsContainer;
